import { createAction } from "redux-act";

export const REQPushNotiList = createAction("REQUEST_PUSH_NOTI_LIST");
export const RESPushNotiList = createAction("RECEIVE_PUSH_NOTI_LIST");
export const FailPushNotiList = createAction("FAILED_PUSH_NOTI_LIST");
export const DELPushNotiCampaign = createAction("DELETE_PUSH_NOTI_CAMPAIGN");
export const CleanUpPushNotiList = createAction("CLEANUP_PUSH_NOTI_LIST");
